export const state = {
	ticketReasonList : [],
	ticketData : [],
	ticketList : [],
	ticketView : []
}


// WEBPACK FOOTER //
// ./src/plugins/support/provider/store-addons/state.js